import React from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';
import c from 'classnames';

interface Props {
  title: string;
  href: string;
  className?: string;
}

const LinkListItem = (props: Props) => {
  const {
    title,
    href,
    className,
  } = props;

  const classes = c('Footer__link-list-item', className);

  return (
    <li className={classes}>
      <CoreLink
        to={href}
      >
        {title}
      </CoreLink>
    </li>
  );
};

export default LinkListItem;
